export default {
  loadingStep: {
    infoText: 'Estamos atualizando a informação da sua entrega...'
  }
};
